import { Component } from '@angular/core';

@Component({
    selector: 'app-no-roles-dialog-body',
    templateUrl: './no-roles-dialog-body.component.html',
    styleUrls: ['./no-roles-dialog-body.component.scss']
})
export class NoRolesDialogBodyComponent {}
